import styled from 'styled-components';
import Button from '../button/Button';
export const HelpBoxWrapper = styled.div ``;
export const BoxContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  margin: 1.5rem;
  padding: 2.5rem 0.5rem 3.5rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const ButtonWrapper = styled.div `
  width: 20rem;
  height: 4rem;
`;
export const CustomButton = styled(Button) `
  width: 19rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highL};
  margin-top: 1.8rem;
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
  position: absolute;
`;
export const CustomImage = styled.img `
  display: none;
  position: absolute;
  margin-left: 1.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.tablet `
    display: block;
  `}
`;
export const CustomMobileImage = styled.img `
  position: absolute;
  margin-left: 1.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  ${({ theme }) => theme.media.tablet `
    display: none;
  `}
`;
//# sourceMappingURL=styles.js.map